<template>
  <IconLucideMoveUpRight />
</template>
